import TextEditor from "@/components/TextEditor";
import { globalModalProps } from "@/constant/globalConstant";
import { useCreateSupportResponseMutation, useUpdateSupportResponseMutation } from "@/redux/api/supportResponseApi";
import { App, Button, Form } from "antd";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";

const ResponseForm = ({ mode = "create", support }) => {
  // hooks
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { notification, modal } = App.useApp();
  const { id } = useParams();
  const user = useSelector((state) => state.user?.userDetails) || {};

  // rtk query
  const [create, { isLoading: createLoading }] = useCreateSupportResponseMutation();
  const [update, { isLoading: updateLoading }] = useUpdateSupportResponseMutation();

  const handleSubmit = async (values) => {
    const body = { message: values.message, sender: user?._id, support: support?._id };

    await modal.confirm({
      ...globalModalProps,
      content: `Do you wish to send this reply to user?`,
      onOk: async () => {
        try {
          const res = mode === "edit" ? await update({ id, body }).unwrap() : await create(body).unwrap();

          if (res?.success) {
            notification.success({
              message: `Reply sent successfully to user.`,
              duration: 2,
              showProgress: true,
            });
            form.resetFields();
            // navigate(-1);
          }
        } catch (error) {
          notification.error({
            message: error?.data?.message || "Something went wrong. Please try again.",
            duration: 2,
            showProgress: true,
          });
        }
      },
    });
  };

  const loading = createLoading || updateLoading;

  return (
    <div className="support-form">
      <h2 className="fs-6 fw-bold mb-4">Send a Reply</h2>

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label=""
          getValueFromEvent={(content) => content}
          name="message"
          rules={[{ required: true, message: "Please enter your message" }]}
        >
          <TextEditor placeholder="Write your message here..." />
        </Form.Item>

        <div className="d-flex justify-content-end gap-2">
          <Button type="primary" disabled={loading} htmlType="submit">
            Send
          </Button>
          <Button onClick={() => navigate(-1)}>Back</Button>
        </div>
      </Form>
    </div>
  );
};

export default ResponseForm;

ResponseForm.propTypes = {
  mode: PropTypes.string,
  support: PropTypes.object,
};
